export interface ISearchField {
    startDate: Date;
    duration: number;
}
export class SearchField implements ISearchField {
    startDate: Date;
    duration: number;

    constructor(startDate: Date = null, duration: number = null) {
        this.startDate = startDate;
        this.duration = duration;
    }
}
